export default "__VITE_ASSET__a9ffb2b1__"